// extracted by mini-css-extract-plugin
export default {"root":"Wallet_root__4LVjK","price":"Wallet_price__Q76ra","item":"Wallet_item__6ismc","label":"Wallet_label__U-ZEa"};